/**
 * The characters a folder name may hold, mirroring `validateFolderPath` in the API's
 * `user-filesystem-utils`. A name becomes one segment of the folder's key, so anything outside this
 * set has to be kept out of the name — "/" and "\" above all, since the key joins the parent path
 * and the name together and a separator inside the name reads as another level of folders.
 */
const INVALID_FOLDER_NAME_CHARACTER = /[^A-Za-z0-9-_\s~`\[\]!@#$%^&()=,;.]/g;

/** The characters of a folder name the API would reject, each listed once, in the order typed. */
export const getInvalidFolderNameCharacters = (name: string): string[] =>
  Array.from(new Set(name.match(INVALID_FOLDER_NAME_CHARACTER) || []));
